export default __webpack_public_path__ + "static/1-f0c28d2ffd72bcb9d953a070a9ec0194.png";